(ns frontend.ui.component.lp-portal.report.body.real-estate.fund.koke.controller.details-and-figures
  (:require
   [frontend.ui.page.lp-portal.report.util :as util]
   [frontend.ui.component.lp-portal.report.controller :as report-ctl]))

(defn details-and-figures
  [{:keys [report-data] :as props}]
  {:current-portfolio    (report-ctl/with-footnote
                          props
                          :current-portfolio-footnotes
                          (:current-portfolio report-data))
   #_#_:exited-portfolio     (report-ctl/with-footnote
                          props
                          :exited-portfolio-footnotes
                          (:exited-portfolio report-data))
   :investment-summary   (report-ctl/with-footnote
                          props
                          :investment-summary-footnotes
                          (:investment-summary report-data))
   :limited-partners     (report-ctl/with-footnote
                          props
                          :limited-partners-footnotes
                          (:limited-partners report-data))
   #_#_:senior-loan-facility (report-ctl/with-footnote
                          props
                          :senior-loan-facility-footnotes
                          (:senior-loan-facility report-data))
   :nav-breakdown        (report-ctl/with-footnote
                          props
                          :nav-breakdown-footnotes
                          (get-in report-data [:nav-breakdown]))})
